export const loginImage = require('./Files/login.jpg');
export const automatisationStepBackground = require('./Files/background_steps.png');
export const webhook = require('./Files/webhook.png');
export const split = require('./Files/split.png');
export const iteration = require('./Files/iteration.png');
export const logo = require('./Files/hoodle.png');
export const logoWithName = require('./Files/hoodle.png');
export const thunder = require('./Files/thunder.png');